export const LOGIN = 'LOGIN';
export const SET_TOKEN = "SET_TOKEN";
export const LOGOUT = 'LOGOUT';
export const NEEDS_LOGIN = 'NEEDS_LOGIN';